// extracted by mini-css-extract-plugin
export default {"root":"CompleteAppointmentModal_root__pC53q","heading":"CompleteAppointmentModal_heading__9K9yI","actions":"CompleteAppointmentModal_actions__brFAw"};